"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledDisabledTabItemWrapper = exports.StyledInvertedTabItemWrapper = exports.StyledDefaultTabItemWrapper = exports.StyledMasterTabItemWrapper = exports.StyledTabNumber = exports.StyledTabLabel = exports.StyledTabItem = exports.StyledTabs = void 0;
const theme_1 = require("@icr-ui/theme");
const utils_1 = require("@icr-ui/utils");
const styled_components_1 = __importStar(require("styled-components"));
const flexbox_1 = require("../flexbox");
const typography_1 = require("../typography");
const utils_2 = require("./utils");
exports.StyledTabs = (0, styled_components_1.default)(flexbox_1.Flexbox) `
  ${(props) => {
    return (0, styled_components_1.css) `
      gap: ${theme_1.spacings.s6};
      ${props.fullWidth &&
        (0, styled_components_1.css) `
        @media (max-width: 883px) {
          flex-wrap: nowrap;
        }
      `}
    `;
}}
  @media (max-width: 360px) {
    gap: 0.75rem;
  }
`;
exports.StyledTabItem = (0, styled_components_1.default)(flexbox_1.Flexbox) `
  position: relative;
  font-size: ${(0, utils_1.pxToRem)(14)};
  align-items: center;
  line-height: ${theme_1.fonts.button.small.lineHeight};
  letter-spacing: -0.009rem;
  text-transform: uppercase;

  &::after {
    content: '';
    position: absolute;
    bottom: 0;
    left: 2px;
    width: 0;
    height: ${theme_1.spacings.s0};
    background-color: ${({ inverted }) => !inverted ? theme_1.primary.light : theme_1.grayScale[50]};

    transition: width 0.3s ease;
  }
`;
exports.StyledTabLabel = (0, styled_components_1.default)(typography_1.Typography) `
  margin: 0;
  width: max-content;
  align-self: flex-start;
`;
exports.StyledTabNumber = (0, styled_components_1.default)(flexbox_1.Flexbox) `
  width: ${theme_1.spacings.s7};
  height: ${theme_1.spacings.s5};
  border-radius: ${theme_1.borders.radius.tag};
  margin-left: ${(0, utils_1.pxToRem)(8.5)};
  padding: 0;
  font-weight: ${theme_1.fonts.button.small.fontWeight};
  align-self: flex-start;
  @media (max-width: 768px) {
    display: none;
  }
`;
exports.StyledMasterTabItemWrapper = (0, styled_components_1.default)(flexbox_1.Flexbox) `
  ${(props) => {
    const { inverted, activeTab, currentElement, disabled, height, fullWidth } = props;
    const isActive = activeTab === currentElement;
    const afterLineColor = !inverted ? theme_1.primary.dark : (0, utils_1.hexToRgba)(theme_1.grayScale[50], 0.8);
    const shadowLineColor = !inverted ? theme_1.primary.dark : theme_1.grayScale[50];
    return (0, styled_components_1.css) `
      height: ${height ? height : (0, utils_1.pxToRem)(34)};
      padding: 0;
      border-radius: ${!isActive ? theme_1.spacings.s2 : 0};
      cursor: ${disabled ? 'not-allowed' : 'pointer'};
      ${(0, utils_1.getFocusStyles)('transparent')};

      ${height === '100%' &&
        (0, styled_components_1.css) `
        ${exports.StyledTabLabel} {
          align-self: center;
        }
        ${exports.StyledTabNumber} {
          align-self: center;
        }
      `}

      &:hover {
        ${(0, utils_2.GetLabelHoverStyles)(inverted)}
        ${(0, utils_2.GetBadgeHoverStyles)(inverted)}
        ${exports.StyledTabItem} {
          &::after {
            background-color: ${afterLineColor};
          }
        }
      }

      &:focus-visible,
      &:focus-within {
        ${exports.StyledTabLabel} {
          color: ${inverted ? theme_1.grayScale[50] : theme_1.primary.dark};
        }
        ${exports.StyledTabNumber} {
          background-color: ${inverted ? theme_1.grayScale[50] : theme_1.primary.dark};
          color: ${inverted ? theme_1.primary.dark : theme_1.grayScale[50]};
        }
        ${exports.StyledTabItem} {
          &::after {
            width: calc(100% - 4px);
            background-color: ${shadowLineColor};
          }
        }
        height: ${height ? height : (0, utils_1.pxToRem)(42)};
        padding: 4px;
        box-shadow: ${theme_1.shadows.containedFocus(shadowLineColor, shadowLineColor)};
        border-radius: ${theme_1.spacings.s2};
      }
      ${fullWidth &&
        (0, styled_components_1.css) `
        @media (max-width: 883px) {
          ${exports.StyledTabItem} {
            flex: 1;
            align-items: center;
            justify-content: center;
          }
        }
      `}
    `;
}}
`;
exports.StyledDefaultTabItemWrapper = (0, styled_components_1.default)(exports.StyledMasterTabItemWrapper) `
  ${(props) => {
    return (0, styled_components_1.css) `
      ${exports.StyledTabLabel} {
        color: ${theme_1.grayScale[600]};
      }
      ${exports.StyledTabNumber} {
        background-color: ${theme_1.grayScale[600]};
        color: ${theme_1.grayScale[50]};
      }
      ${(0, utils_2.GetTabActiveStyles)(props)}
    `;
}}
`;
exports.StyledInvertedTabItemWrapper = (0, styled_components_1.default)(exports.StyledMasterTabItemWrapper) `
  ${(props) => {
    const { inverted, activeTab, currentElement } = props;
    const isActive = activeTab === currentElement;
    const defaultOpacity = inverted ? 0.77 : 1;
    return (0, styled_components_1.css) `
      ${exports.StyledTabLabel} {
        color: ${theme_1.grayScale[50]};
      }
      ${exports.StyledTabNumber} {
        background-color: ${theme_1.grayScale[50]};
        color: ${theme_1.primary.main};
      }
      ${!isActive &&
        (0, styled_components_1.css) `
        *:not(:hover) {
          opacity: ${defaultOpacity};
        }
      `}
      ${(0, utils_2.GetTabActiveStyles)({ ...props, inverted: true })}
    `;
}}
`;
exports.StyledDisabledTabItemWrapper = (0, styled_components_1.default)(exports.StyledMasterTabItemWrapper) `
  ${({ inverted }) => {
    const disabledStyles = (0, styled_components_1.css) `
      ${exports.StyledTabLabel} {
        color: ${inverted ? (0, utils_1.hexToRgba)(theme_1.grayScale[50], 0.2) : theme_1.grayScale[400]};
      }
      ${exports.StyledTabNumber} {
        background-color: ${inverted ? (0, utils_1.hexToRgba)(theme_1.grayScale[50], 0.2) : theme_1.grayScale[400]};
        color: ${inverted ? theme_1.primary.main : theme_1.grayScale[50]};
      }
    `;
    return (0, styled_components_1.css) `
      ${disabledStyles}
      &:hover {
        ${disabledStyles}
        cursor: not-allowed;
        &:after {
          display: none;
        }
      }
    `;
}}
`;
//# sourceMappingURL=styles.js.map